import { useContext } from 'react';
import { Mentor } from '../../api/mentors';
import { useMyMentorsContext } from '../../contexts/my-mentors-context';
import { useResourceBundles } from '../../contexts/resource-bundles-context';
import { UserContext } from '../../contexts/user-context';
import TableActions from '../common/table-actions';

function MyMentorsRowActions({
  mentor,
  variant,
}: {
  mentor: Mentor;
  variant?: 'table' | 'list';
}) {
  const { rb } = useResourceBundles();
  const { hasAccessToAction } = useContext(UserContext);
  const { setWriteReviewTargetMentor, setManageMentorTargetMentor } =
    useMyMentorsContext();

  return (
    <TableActions
      variant={variant}
      actions={[
        {
          key: 'row-action-write-review',
          onClick: () => setWriteReviewTargetMentor(mentor),
          label: 'Write a review',
          hidden: !hasAccessToAction('mentor.details.writeReview'),
        },
        {
          key: 'row-action-manage-mentor',
          onClick: () => setManageMentorTargetMentor(mentor),
          label: `Manage ${rb('mentor-u')}`,
          hidden: !hasAccessToAction('mentor.details.manageMentor'),
        },
      ]}
    />
  );
}

export default MyMentorsRowActions;
